const badgeStyle: React.CSSProperties = {
  position: 'absolute',
  top: 2,
  right: 2,
  background: '#fff1f0',
  color: '#cf1322',
  fontSize: 9,
  fontWeight: 600,
  lineHeight: 1,
  padding: '1px 5px',
  borderRadius: 8,
  border: '1px solid #ffccc7',
  whiteSpace: 'nowrap',
  zIndex: 1,
  pointerEvents: 'none',
}

export const NewTag = () => <span style={badgeStyle}>New</span>

/**
 * Use as a column's `onCell` so the cell (the row's rightmost `<td>`)
 * becomes the positioning anchor for `<NewTag />`, pinning it to the
 * top-right corner of the record. Preserves any existing onCell props
 * (e.g. row-click handlers).
 */
export const cornerBadgeOnCell =
  <T,>(base?: (record: T) => Record<string, any>) =>
  (record: T) => {
    const extra = base ? base(record) : {}
    return {
      ...extra,
      style: { position: 'relative', ...(extra.style || {}) },
    }
  }
